import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Layout/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/PageLayouts/BlogsPageLayout.tsx");
